import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Access from "@/pages/Access";
import Mastermind from "@/pages/Mastermind";
import Ebook from "@/pages/Ebook";
import Course from "@/pages/Course";
import Camp from "@/pages/Camp";
import Admin from "@/pages/Admin";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ExitIntentModal from "@/components/ExitIntentModal";
import ScrollToTop from "@/components/ScrollToTop";
import ChatWidget from "@/components/ChatWidget";
import { Toaster } from "sonner";
import { useLocation } from "react-router-dom";

function Chrome({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Navbar />}
      <main>{children}</main>
      {!isAdmin && <Footer />}
      {!isAdmin && <ExitIntentModal />}
      {!isAdmin && <ChatWidget />}
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-ink-900 text-white">
      <BrowserRouter>
        <ScrollToTop />
        <Chrome>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/access" element={<Access />} />
            <Route path="/mastermind" element={<Mastermind />} />
            <Route path="/ebook" element={<Ebook />} />
            <Route path="/course" element={<Course />} />
            <Route path="/camp" element={<Camp />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </Chrome>
        <Toaster position="top-center" theme="dark" />
      </BrowserRouter>
    </div>
  );
}

export default App;
